import ican from '@cryptohub/ican';
import { ENVIRONMENT } from '@ping/configs';
import multicoin from 'multicoin-address-validator';
import { customInstance } from '@ping/api/custom-instance';

// Dynamic Core currencies - will be populated from API
let CORE_CURRENCIES = new Set([
  'xcb',
  'xce',
  'xab',
  'ctn',
  'cts',
  'ceur',
  'cusd',
  'usdx',
  'rwasbg5',
  'rwaswsg5',
  'rwazch5',
  'sugar',
  'snft',
  'pnft',
]);

// Fetch network data on module load
const initializeNetworkData = async () => {
  try {
    const response: any = await customInstance({
      url: '/frontoffice/api/wallet/networks',
      method: 'GET',
    });

    if (response && Array.isArray(response)) {
      // Find CoreBlockchain network and extract its assets
      const coreNetwork = response.find(
        (network: any) => network.name && network.name.toLowerCase() === 'coreblockchain'
      );
      if (coreNetwork && coreNetwork.assets && Array.isArray(coreNetwork.assets)) {
        // Update CORE_CURRENCIES with dynamic data
        CORE_CURRENCIES = new Set(coreNetwork.assets.map((asset: string) => asset.toLowerCase()));
      }
    }
  } catch (error) {
    console.log('Failed to fetch network data, using fallback Core currencies:', error);
  }
};

// Initialize network data immediately when module loads
initializeNetworkData();
const NETWORK_BASED_ON_ENV = new Map<typeof ENVIRONMENT, string>()
  .set('develop', 'both')
  .set('staging', 'both')
  .set('testnet', 'both')
  .set('production', 'prod');

// const LITECOIN_REGEX = {
//   LEGACY: /^[LM][a-km-zA-HJ-NP-Z1-9]{26,34}$/,
//   BECH32: /^ltc1[a-z0-9]{39,59}$/,
// };

interface IIsValidAddressInput {
  address: string;
  assetId: string;
  network?: string;
}

/**
 * It checks if an address is valid based on the asset ID and network environment.
 * @param {IIsValidAddressInput} input - The input parameter is an object with the following
 * properties:
 * - address
 * - assetId
 */
export const isValidAddress = (input: IIsValidAddressInput) => {
  let output = false;
  const assetId = input.assetId.toLowerCase();

  try {
    if (CORE_CURRENCIES.has(assetId)) {
      output = ican.isValid(input.address);
    } else if (assetId === 'ltc') {
      // Custom validation for Litecoin addresses
      //ToDo remove validation for litecoin for release
      return true;
      // output = LITECOIN_REGEX.LEGACY.test(input.address) || LITECOIN_REGEX.BECH32.test(input.address);
    } else {
      output = multicoin.validate(
        input.address,
        assetId === 'pol' ? 'eth' : assetId, //check pol with eth network
        NETWORK_BASED_ON_ENV.get(ENVIRONMENT)
      );
    }

    // TODO: for testing 86bwhe0zg
    // console.log('isValidAddress', output, input, ENVIRONMENT, NETWORK_BASED_ON_ENV.get(ENVIRONMENT));
  } catch (error) {
    console.log('Error in isValidAddress', error);
    output = false;
  }

  return output;
};
